import { CheckCircle2, Info } from "lucide-react";
const requirements = [
  {
    text: "Mindestalter von 18 Jahren",
    detail: "",
  },
  {
    text: "Mindestgewicht von 50 kg",
    detail: "",
  },
  {
    text: "Aktuell für eine Spende geeignet",
    detail: "(wird medizinisch geprüft)",
  },
  {
    text: "Gültiger Personalausweis oder Reisepass",
    detail: "",
  },
  {
    text: "Keine akuten Infektionskrankheiten",
    detail: "",
  },
  {
    text: "Mindestens 2 Kalendertage Abstand zwischen Plasmaspenden",
    detail: "",
  },
];

const Requirements = () => {
  return (
    <section
      className="section-screen bg-background scroll-mt-20 md:scroll-mt-0"
      id="voraussetzungen"
      aria-labelledby="requirements-heading"
    >
      <div className="container container-narrow">
        <h2
          id="requirements-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-4 font-display"
        >
          <span className="text-foreground">Voraussetzungen für </span>
          <span className="text-gradient">Plasmaspenden</span>
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-xl mx-auto text-lg">
          Das sind grundlegende Kriterien; die Spendefähigkeit wird individuell geprüft.
        </p>

        <div className="card-modern p-8 md:p-10 glow-accent">
          <ul className="grid sm:grid-cols-2 gap-5" role="list">
            {requirements.map((req, index) => (
              <li key={index} className="flex items-center gap-4 group">
                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-accent/20 flex items-center justify-center group-hover:bg-accent/30 transition-colors">
                  <CheckCircle2 className="w-5 h-5 text-accent" />
                </div>
                <div>
                  <span className="text-foreground font-medium">
                    {req.text}
                  </span>
                  {req.detail && (
                    <span className="text-muted-foreground text-sm ml-1">
                      {req.detail}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-8 pt-8 border-t border-border">
            <div className="flex items-start gap-4 glass-card rounded-xl p-5">
              <Info className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
              <p className="text-sm text-muted-foreground">
                <strong className="text-foreground">Hinweis:</strong> Die
                endgültige Eignung wird vor jeder Spende durch das ärztliche
                Personal geprüft. Eine allgemeine Höchstaltersgrenze gibt es
                nicht. Medikamente, Reisen, Vorerkrankungen und weitere
                Umstände können die Spendefähigkeit beeinflussen. Maßgeblich
                ist die individuelle Beurteilung im Zentrum. Quelle: <a
                  href="https://www.blutspenden.de/blut-und-plasmaspende/voraussetzungen-fuer-eine-blut-oder-plasmaspende/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-2 hover:text-foreground"
                >BIÖG – Voraussetzungen</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Requirements;
